const calculatePagesCount = (
  itemsPerPage: number,
  totalCount: number
): number => Math.ceil(totalCount / itemsPerPage);

export default calculatePagesCount;
